import * as Yup from 'yup';

const phoneRegExp = /^\+?[1-9]\d{1,14}$/;

const validatePhoneNumber = (phone, country) => {
  if (!phone) return false;

  const lengths = {
    US: 10,
  };

  const numberOnly = phone.replace(/\D/g, '');
  const requiredLength = lengths[country] || 10;

  return numberOnly.length === requiredLength;
};

export const signUpValidationSchema = Yup.object().shape({
  full_name: Yup.string()
    .required('Full Name is required')
    .matches(
      /^[a-zA-Z]+(?: [a-zA-Z]+)*$/,
      'Full Name must contain only letters'
    ),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be atleast 8 characters long'),
  password_confirmation: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords do not match')
    .required('Please re-enter your new password'),
  phone: Yup.string().required('Phone number is required'),
  // .test('phone', 'Invalid phone number for selected country', function(value) {
  //   const country = this.parent.country || 'US';
  //   return validatePhoneNumber(value, country);
  // })
  // .matches(phoneRegExp, 'Phone number is not valid'),
  // profile_image: Yup.mixed()
  //   .required('Profile image is required')
  //   .test('fileSize', 'File is too large', (value) => {
  //     if (!value) return true;
  //     return value.size <= 5000000; // 5MB limit
  //   })
  //   .test('fileType', 'Unsupported file type', (value) => {
  //     if (!value) return true;
  //     return ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type);
  //   }),
});
export const changePasswordValidation = Yup.object().shape({
  current_password: Yup.string().required('Current Password is required'),
  password: Yup.string()
    .required('New Password is required')
    .min(8, 'Password must be atleast 8 characters long'),
  password_confirmation: Yup.string()
    .required('Confirm Password is required')
    .oneOf([Yup.ref('password'), null], 'Passwords do not match.')
    .label('Confirm Password'),
});
export const loginValidationSchema = Yup.object().shape({
  email: Yup.string().required('Email is required'),
  password: Yup.string()
    // .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
});

export const forgotEmail = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email address is required'),
});

export const forgotCode = Yup.object().shape({
  verificationCode: Yup.string()
    .required('Verification code is required')
    .matches(/^\d{4}$/, 'Verification code must be 4 digits'),
});

// export const SubscriptionValidationSchema = Yup.object().shape({
//   title: Yup.string().required('Subscription Title is required'),
//   duration: Yup.string().required('Duration is required'),
//   type: Yup.string().required('Subscription Type is required'),
//   price: Yup.number()
//     .typeError('Amount  must be a number')
//     .required('Amount is required')
//     .positive('Amount must be greater than zero'),
//   discount: Yup.string().required('Discount is required'),
//   coins: Yup.number()
//     .required('Coins is required')
//     .positive('Coins must be greater than zero'),
//   description: Yup.string().required('Description is required'),
// });


// SubscriptionValidationSchema.js mein
export const SubscriptionValidationSchema = Yup.object({
  name: Yup.string().required('Subscription name is required'),
  interval: Yup.string().required('Duration is required'),
  price: Yup.number()
    .required('Price is required')
    .min(0, 'Price must be positive'),
  discount: Yup.number()
    .min(0, 'Discount cannot be negative')
    .max(100, 'Discount cannot exceed 100%'),
  coins: Yup.number()
    .min(0, 'Coins cannot be negative'),
  description: Yup.string(),
});




export const AffilateValidationSchema = Yup.object().shape({
  full_name: Yup.string().required('First Name is required'),
  // last_name: Yup.string().required('Last Name is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  phone: Yup.string().required('Phone Number is required'),
  password: Yup.string().required('Password is required'),
  password_confirmation: Yup.string()
    .required('Confirm Password is required')
    .oneOf([Yup.ref('password'), null], 'Passwords do not match')
    .label('Confirm Password'),
  photo: Yup.array()
    .min(1, "Image is required") 
});

export const AffilateEditValidationSchema = Yup.object().shape({
  full_name: Yup.string().required('First Name is required'),
  // last_name: Yup.string().required('Last Name is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  phone: Yup.string().required('Phone Number is required'),
  photo: Yup.array()
    .min(1, "Image is required"),
});


export const RefralValidationSchema = Yup.object().shape({
  coins: Yup.string().required('Refral coins is required'),
});

// export const BundleValidationSchema = Yup.object().shape({
//   coin: Yup.string().required('Coin quantity required'),
//   coin_quantity: Yup.string().required('Coin quantity required'),
//   price: Yup.number()
//     .typeError('Price  must be a number')
//     .required('Price is required')
//     .positive('Price must be greater than zero'),
// });


// BundleValidationSchema.js mein
export const BundleValidationSchema = Yup.object({
  name: Yup.string().required("Bundle name is required"),
  coins: Yup.number().required("Coin quantity is required").min(1, "Must be at least 1"),
  price: Yup.number().required("Price is required").min(0, "Price cannot be negative"),
});





export const CommissionValidationSchema = Yup.object().shape({
  commission: Yup.string().required('Commission rate is required'),
});

export const GreetingCardValidationSchema = Yup.object({
  title: Yup.string().required('Greeting card name is required'),
  coins: Yup.number().required('Coins are required'),
  description: Yup.string().required('Description is required'),
  // gift_img: Yup.string().required("Image is required"),
  // gift_img: Yup.mixed()
  // .required("Image is required")
  // .test("fileRequired", "Image is required", (value) => {
  //   return value && value.length > 0;
  // })
});

export const forgotPassword = Yup.object().shape({
  password: Yup.string()
    // .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
  password_confirmation: Yup.string()
    .required('Confirm Password is required')
    .oneOf([Yup.ref('password'), null], 'Passwords do not match')
    .label('Confirm Password'),
});
export const adminLoginValidationSchema = Yup.object().shape({
  email: Yup.string().required('Email is required'),
  password: Yup.string()
    // .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
});

export const editAdminProfileSchema = Yup.object({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
});

export const editProfileSchema = Yup.object({
  business_name: Yup.string().required('Business name is required'),
  user_name: Yup.string().required('User name is required'),
  phone: Yup.string().required('Phone Number is required'),
});
export const changePasswordSchema = Yup.object({
  current_password: Yup.string().required('Current Password is required'),
  password: Yup.string().required('New Password is required'),
  password_confirmation: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords do not match')
    .required('Please re-enter your new password'),
});

export const locationValidationSchema = Yup.object().shape({
  location: Yup.mixed().required('Location is required'),
  city: Yup.string().required('City is required'),
  state: Yup.string().required('State is required'),
  zip_code: Yup.string().required('Zip code is required'),
});
